import medicine from "./medicineActiveIcon.svg";
import doctorActiveIcon from "./doctorActiveIcon.svg";
import patient from "./patientActiveIcon.svg";
import purchaseInvoiceActiveIcon from "./purchaseInvoiceActiveIcon.svg";
import salesInvoiceActiveIcon from "./salesInvoiceActiveIcon.svg";
import generic from "./generic.svg";
import manufacturer from "./manufacturer.svg";
import callIcon from "./callIcon.svg";
import chatIcon from "./chatIcon.svg";
import gmailIcon from "./gmailIcon.svg";
import whatsappIcon from "./whatsappIcon.svg";
import allIcon from "./all.svg";
import purchaseIcon from "./purchase.svg";
import moreIcon from "./more.svg";
import salesIcon from "./sales.svg";
import dashboardIcon from "./dashboard.svg";
import paymentsIcon from "./paymentsIcon.svg";
import doctorIcon from "./doctorIcon.svg";
import manufacturerIcon from "./manufacturerIcon.svg";
import medicineIcon from "./medicineIcon.svg";
import reportsIcon from "./reportsIcon.svg";
import accountsIcon from "./accountsIcon.svg";
import migrationIcon from "./migrationIcon.svg";
import loyaltyManagementIcon from "./loyaltyManagementIcon.svg";
import mastersIcon from "./mastersIcon.svg";
import returnsIcon from "./returnsIcon.svg";
import patientIcon from "./patientIcon.svg";
import purchaseInvoiceIcon from "./purchaseInvoiceIcon.svg";
import salesActiveIcon from "./salesActiveIcon.svg";
import purchaseActiveIcon from "./purchaseActiveIcon.svg";
import reportsActiveIcon from "./reportsActiveIcon.svg";
import paymentsActiveIcon from "./paymentsActiveIcon.svg";
import accountsActiveIcon from "./accountsActiveIcon.svg";
import mastersActiveIcon from "./mastersActiveIcon.svg";
import returnsActiveIcon from "./returnsActiveIcon.svg";
import configurationIcon from "./configuration.svg";
import salesInvoiceIcon from "./salesInvoiceIcon.svg";
import calculationActiveIcon from "./calculationActiveIcon.svg";
import compositionActiveIcon from "./compositionActiveIcon.svg";
import demandBookActiveIcon from "./demandBookActiveIcon.svg";
import paymentAlertActiveIcon from "./paymentAlertActiveIcon.svg";
import expiryAlertActiveIcon from "./expiryAlertActiveIcon.svg";
import mailAlertActiveIcon from "./mailAlertActiveIcon.svg";
import dashboardActiveIcon from "./dashboardActiveIcon.svg";
import loyaltyManagementActiveIcon from "./loyaltyManagementActiveIcon.svg";
import migrationActiveIcon from "./migrationActiveIcon.svg";
import salesReturnActiveIcon from "./salesReturnActiveIcon.svg";
import purchaseReturnActiveIcon from "./purchaseReturnActiveIcon.svg";
import customerPaymentActiveIcon from "./customerPaymentActiveIcon.svg";
import distributorPaymentActiveIcon from "./distributorPaymentActiveIcon.svg";
import gstReportIcon from "./gstreporticon.svg";
const images = {
  medicine,
  doctorActiveIcon,
  patient,
  salesInvoiceActiveIcon,
  purchaseInvoiceActiveIcon,
  generic,
  manufacturer,
  callIcon,
  chatIcon,
  gmailIcon,
  whatsappIcon,
  allIcon,
  purchaseIcon,
  moreIcon,
  salesIcon,
  dashboardIcon,
  paymentsIcon,
  doctorIcon,
  manufacturerIcon,
  medicineIcon,
  reportsIcon,
  accountsIcon,
  migrationIcon,
  loyaltyManagementIcon,
  mastersIcon,
  returnsIcon,
  patientIcon,
  purchaseInvoiceIcon,
  salesActiveIcon,
  purchaseActiveIcon,
  reportsActiveIcon,
  paymentsActiveIcon,
  accountsActiveIcon,
  mastersActiveIcon,
  returnsActiveIcon,
  configurationIcon,
  salesInvoiceIcon,
  calculationActiveIcon,
  compositionActiveIcon,
  demandBookActiveIcon,
  paymentAlertActiveIcon,
  expiryAlertActiveIcon,
  mailAlertActiveIcon,
  dashboardActiveIcon,
  loyaltyManagementActiveIcon,
  migrationActiveIcon,
  salesReturnActiveIcon,
  purchaseReturnActiveIcon,
  customerPaymentActiveIcon,
  distributorPaymentActiveIcon,
  gstReportIcon,
};
export default images;
